import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './signIn.css';
import Footer from '../../components/Footer/Footer';
import { signIn, getProfile } from '../../api/api.js';
import Notification from '../../components/notification.js';

const SignIn = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: '',
    password: '',
    rememberMe: false,
  });
  
  const [errors, setErrors] = useState({});
  const [notification, setNotification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!form.email) {
      newErrors.email = 'Email is required.';
    } else if (!emailRegex.test(form.email)) {
      newErrors.email = 'Please enter a valid email.';
    }

    if (!form.password) {
      newErrors.password = 'Password is required.';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      try {
        const data = await signIn({ email: form.email, password: form.password });

        if (data && data.status === 201) {
          setNotification({ type: 'success', message: 'Verification code sent.' });
          navigate('/otp', { state: { email: form.email } });
        } else if (data && data.status === 200) {
          setNotification({ type: 'success', message: 'Sign-In successful!' });
          const { token } = data.data.data;
          localStorage.setItem('authToken', token);

          try {
            const token = localStorage.getItem('authToken');
            if (!token) {
              setNotification({ type: 'error', message: 'Please sign in to view your profile.' });
              navigate('/sign-in');
              return;
            }

            const response = await getProfile();
            console.log(response);
            if (response.status === 200) {
              const profileData = response.data;
              localStorage.setItem('userProfile', JSON.stringify(profileData));
              localStorage.setItem('userCredits', profileData.credits.toString());
              localStorage.setItem('userId', profileData.userId);
              window.dispatchEvent(new Event('storage'));
            }
          } catch (error) {
            console.log(error);
            if (error.response?.status === 401) {
              setNotification({ type: 'error', message: 'Session expired. Please sign in again.' });
              localStorage.removeItem('userProfile');
              localStorage.removeItem('userCredits');
              navigate('/sign-in');
            } else if (error.response?.status === 404) {
              setNotification({ type: 'error', message: 'Profile not found.' });
            } else {
              setNotification({
                type: 'error',
                message: 'Failed to fetch profile data.'
              });
            }
          }

          navigate('/generate');
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.data?.message || 'An error occurred during sign-in.';
        setNotification({ type: 'error', message: errorMessage });
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value,
    });

    setErrors({
      ...errors,
      [name]: '',
    });
  };

  const handleCloseNotification = () => {
    setNotification(null);
  };

  return (
    <div className="page-container">
      <main className="main-content">
        <div className="signin-container">
          <form className="signin-form" onSubmit={handleSubmit}>
            <h2 className="signin-title">Sign In</h2>

            <div className="signin-form-group">
              <label htmlFor="email" className="signin-label">
                Email<span className="signin-required">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                className={`signin-input ${errors.email ? 'signin-input-error' : ''}`}
                placeholder="Enter your email"
                disabled={isLoading}
              />
              {errors.email && <span className="signin-error">{errors.email}</span>}
            </div>

            <div className="signin-form-group">
              <label htmlFor="password" className="signin-label">
                Password<span className="signin-required">*</span>
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                className={`signin-input ${errors.password ? 'signin-input-error' : ''}`}
                placeholder="Enter your password"
                disabled={isLoading}
              />
              {errors.password && <span className="signin-error">{errors.password}</span>}
            </div>

            <div className="signin-options">
              <div className="signin-remember-me">
                <input
                  type="checkbox"
                  id="rememberMe"
                  name="rememberMe"
                  checked={form.rememberMe}
                  onChange={handleChange}
                  disabled={isLoading}
                />
                <label htmlFor="rememberMe" className="signin-remember-me-label">
                  Remember Me
                </label>
              </div>
              <Link to="/forgot-password" className="signin-forgot-password">
                Forgot Password?
              </Link>
            </div>

            <button
              type="submit"
              className="signin-submit-button"
              disabled={isLoading}
            >
              {isLoading ? 'Signing In...' : 'Sign In'}
            </button>
          </form>
        </div>
      </main>
      <Footer />

      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={handleCloseNotification}
        />
      )}
    </div>
  );
};

export default SignIn;
